module.exports = __webpack_public_path__ + "static/media/arrow.f77e13e5.svg";